import { render, staticRenderFns } from "./OP_PERF_OFC.vue?vue&type=template&id=165f485a&scoped=true"
import script from "./OP_PERF_OFC.vue?vue&type=script&lang=ts"
export * from "./OP_PERF_OFC.vue?vue&type=script&lang=ts"
import style0 from "./OP_PERF_OFC.vue?vue&type=style&index=0&id=165f485a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f485a",
  null
  
)

export default component.exports